module.exports = __webpack_public_path__ + "static/anga-iscrizione-cat-2bis-materia3-6951666d56655a7ddc11c7a5dbb82785.pdf";